import { useState } from 'react'
import { ChevronDown, ChevronUp, FileText, Clock } from 'lucide-react'

interface QuestionPanelProps {
  title: string
  description: string
  requirements?: string[]
  timeLimit?: string
  isCollapsed?: boolean
  onToggle?: () => void
}

export default function QuestionPanel({
  title,
  description,
  requirements = [],
  timeLimit,
  isCollapsed = false,
  onToggle
}: QuestionPanelProps) {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-blue-100 transition-colors"
        onClick={onToggle}
      >
        <div className="flex items-center space-x-3">
          <FileText className="w-5 h-5 text-blue-600" />
          <h3 className="font-semibold text-blue-900">Question</h3>
          {timeLimit && (
            <div className="flex items-center space-x-1 text-blue-700 bg-blue-200 px-2 py-1 rounded-full text-xs">
              <Clock className="w-3 h-3" />
              <span>{timeLimit}</span>
            </div>
          )}
        </div>
        {onToggle && (
          <button className="text-blue-600 hover:text-blue-800">
            {isCollapsed ? <ChevronDown className="w-4 h-4" /> : <ChevronUp className="w-4 h-4" />}
          </button>
        )}
      </div>

      {!isCollapsed && (
        <div className="px-4 pb-4 space-y-4">
          <div>
            <h4 className="font-medium text-gray-900 mb-2">{title}</h4>
            <p className="text-gray-700 text-sm leading-relaxed">{description}</p>
          </div>

          {requirements.length > 0 && (
            <div>
              <h5 className="font-medium text-gray-900 mb-2">Requirements:</h5>
              <ul className="space-y-1">
                {requirements.map((requirement, index) => (
                  <li key={index} className="text-gray-700 text-sm flex items-start">
                    <span className="text-blue-600 mr-2">•</span>
                    <span>{requirement}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  )
}